<template>
  <div>
    <!-- 头部 -->
    <div id="header">
      <div class="func-top">
        <div style="width:1000px;margin:0 auto;">
          <div class="func-bar">
            <ul>
              <li><a href="/manage-index" class="login-btn" target="_blank">登录</a></li>
              <li><a href="http://58.42.212.233:8089" class="login-btn" target="_blank">回到旧版</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="top">
        <div class="tit">
          <div class="logo"></div>
          <h1>六盘水市钟山区预决算公开</h1>
          <div class="clearfix"></div>
        </div>
        <!-- <div class="nav">
          <a>登录</a>
        </div> -->
      </div>
      <!-- 登录区域 -->
      <div class="hidden_shadow">
        <div class="loginBox">
          <div class="gbBtn"><i title="关闭"></i></div>
          <div class="tit">
            <h1>登录管理后台</h1>
            <div class="cut_line"></div>
          </div>
          <form action="GG?n=login" method="post" id="form">
            <div class="loginInfo">
              <div class="info">
                <span><i></i></span><input type="text" placeholder="账号"  name="users" id="users"/>
              </div>
              <div class="yz_ts" id="yz_zh"></div>
              <div class="info info_mm">
                <span><i></i></span><input type="password" placeholder="密码"  name="pwd" id="pwd"/>
              </div>
              <div class="yz_ts" id="yz_mm"></div>
              <div class="info info_yz">
                <input class="yzm_sr" type="text" id="code_input" placeholder="请输入验证码"/>
                <div class="yzm"  id="v_container"></div>
                <div class="clearfix"></div>
              </div>
              <div class="yz_ts" id="yz_ts" style="height: 14px;"></div>
              <input class="loginBtn" type="submit" value="登&emsp;录" id="my_button"/>
              <!-- <a class="create_zh" href="third_login.jsp" target="_blank">第三方登陆</a> -->
              <a class="create_zh" href="signUp.jsp" target="_blank">注册账号</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "@/api/CommonApi";
import {SysApis} from "@/api/SysApis";

export default {
  name: "F-PageHeader",
  props: {
    title: {
      type: String,
      default: '管理系统'
    }
  },
  data() {
    return {
      labelCol: {span: 5},
      wrapperCol: {span: 16},
      rules: {
        password: [
          {required: true, message: '请输入原密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16位', trigger: 'change'},
        ],
        newPassword: [
          {required: true, message: '请输入新密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16位', trigger: 'change'},
        ],
        againPassword: [
          {required: true, message: '请重复新密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16位', trigger: 'change'},
        ],
      },
      form: {
        password: '',
        newPassword: '',
        againPassword: ''
      },
      show: {
        updatePassword: false
      },
      userInfo: {
        name: ''
      },
    };
  },
  activated() {
  },
  mounted() {
    // this.$router.push({name: 'welcome'})
  },
  methods: {
    showUpdatePassword() {
      this.show.updatePassword = true
    },
    closeUpdatePassword() {
      this.show.updatePassword = false
      this.$refs.ruleForm.resetFields();
    },
    submitUpdatePassword() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.info('success', this.form);
          if (this.form.newPassword !== this.form.againPassword) {
            this.$message.error('两次密码不一致');
            return
          }
          this.$http.post(SysApis.updatePassword, this.form).then(result => {
            if (result.status !== 200) {
              this.$message.error(result.message);
              return;
            }
            this.$message.success(result.message);
            this.closeUpdatePassword()
          }).catch(function (error) {
            console.error('出现错误:', error);
          });
        } else {
          console.log('验证失败');
          return false;
        }
      })
    },
    logout() {
      CommonApi.logout()
    },
  }
}
</script>

<style scoped lang="less">
@import "~@public/reset.css";
@import "~@public/infoShow.css";
</style>
